import { render, staticRenderFns } from "./AdvertiserIndex.vue?vue&type=template&id=4bc4da45&"
import script from "./AdvertiserIndex.vue?vue&type=script&lang=js&"
export * from "./AdvertiserIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports